import { Breadcrumb, Button, Card, Flex, Form, Input, InputNumber, Row, Select, notification, Col, Upload, Image, message } from "antd";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useForm } from "antd/es/form/Form";
import { Atom } from "react-loading-indicators";
import { useInstitucion } from "../../Hooks/Institucion/useInstitucion";
import { UploadOutlined } from '@ant-design/icons';
import API from "../../API";

const ReporteGuardar = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    
    const [cargando, setCargando] = useState(false);
    const [form] = useForm();
    const {instituciones,getAllInstitucion} = useInstitucion();
    const [fileList, setFileList] = useState([]);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState('');

    const miga = [
        { title: <Link to="/">Inicio</Link> },
        { title: <Link to="/reportes">Registrar reporte</Link> }
    ];

    const sendEmail = async (values) => {
        setCargando(true);
        try {
            // Preparar datos del formulario
            const formData = new FormData();
            formData.append('name', values.name);
            formData.append('ins', instituciones.find(i => i._id === values.ins)?.nombre || values.ins);
            formData.append('correo', values.correo);
            formData.append('tel', values.tel);
            formData.append('message', values.message);

            // Agregar archivos al FormData
            fileList.forEach((file, index) => {
                if (file.originFileObj) {
                    formData.append('imagenes', file.originFileObj);
                }
            });

            // Enviar al backend
            const response = await API.post('/reporte/enviar', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.data.success) {
                notification.success({ 
                    message: 'Reporte enviado exitosamente',
                    description: `Se subieron ${response.data.filesUploaded} imagen(es)`
                });
                form.resetFields();
                setFileList([]);
            } else {
                throw new Error(response.data.message || 'Error al enviar el reporte');
            }
        } catch (error) {
            console.error('Error enviando reporte:', error);
            notification.error({ 
                message: 'Error al enviar el reporte', 
                description: error.response?.data?.message || error.message 
            });
        }
        finally {
            setCargando(false);
        }
    };

    // Funciones para manejo de archivos
    const handleFileChange = ({ fileList: newFileList }) => {
        setFileList(newFileList);
    };

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewVisible(true);
    };

    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    };

    const handleRemove = (file) => {
        const newFileList = fileList.filter(item => item.uid !== file.uid);
        setFileList(newFileList);
    };

    const beforeUpload = (file) => {
        // Validaciones de seguridad
        const isImage = file.type.startsWith('image/');
        if (!isImage) {
            message.error('Solo se permiten archivos de imagen!');
            return false;
        }

        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
            message.error('La imagen debe ser menor a 10MB!');
            return false;
        }

        // Validar extensiones permitidas
        const allowedExtensions = /\.(jpg|jpeg|png|gif|webp)$/i;
        if (!allowedExtensions.test(file.name)) {
            message.error('Solo se permiten archivos JPG, PNG, GIF y WEBP!');
            return false;
        }

        return false; // Prevenir subida automática
    };

    const cargarIns = async () => {
        try {
            setCargando(true);
            getAllInstitucion()
        } catch (error) {
            notification.error({ description: error.response?.data?.mensaje || 'Error al cargar instituciones' });
            navigate('/atletas');
        }
        finally {
            setCargando(false);
        }
    };

    useEffect(() => {
        cargarIns();
        if (id) {
           
        }
    }, [id]);

    return (
        <div style={{ padding: 32 }}>
            <Breadcrumb items={miga} />
            <br />
            {cargando ? <Flex align="center" justify="center">
                <Atom color="#32cd32" size="medium" text="" textColor="" />
            </Flex> : 
            <Flex align="center" justify="center">
                <Card style={{ width: '90%', maxWidth: 960 }}>
                    <Form form={form} layout="vertical" onFinish={sendEmail}>
                        <Row gutter={[16, 16]} align="center" justify="center">
                            <Col xs={24} md={16}>
                                <Form.Item name="name" label="Nombre" rules={[{ required: true, message: 'Campo requerido' }]}>
                                    <Input style={{ width: '100%' }} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[16, 16]} align="center" justify="center">
                            <Col xs={24} md={16}>
                                <Form.Item name="ins" label="Institución">
                                    <Select
                                        style={{ width: '100%' }}
                                        options={instituciones.map(i => ({ value: i._id, label: i.nombre }))}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[16, 16]} align="center" justify="center">
                            <Col xs={24} md={16}>
                                <Form.Item name="correo" label="Correo electrónico" rules={[{ required: true, message: 'Campo requerido' }]}>
                                    <Input style={{ width: '100%' }} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[16, 16]} align="center" justify="center">
                            <Col xs={24} md={16}>
                                <Form.Item name="tel" label="Teléfono" rules={[{ required: true, message: 'Campo requerido' }]}>
                                    <InputNumber style={{ width: '100%' }} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[16, 16]} align="center" justify="center">
                            <Col xs={24} md={16}>
                                <Form.Item name="message" label="Descripción" rules={[{ required: true, message: 'Campo requerido' }]}>
                                    <Input.TextArea autoSize={{ minRows: 2, maxRows: 6 }} style={{ width: '100%' }} showCount size="large" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[16, 16]} align="center" justify="center">
                            <Col xs={24} md={16}>
                                <Form.Item label="Imágenes (Opcional)">
                                    <Upload
                                        listType="picture-card"
                                        fileList={fileList}
                                        onChange={handleFileChange}
                                        onPreview={handlePreview}
                                        onRemove={handleRemove}
                                        beforeUpload={beforeUpload}
                                        multiple
                                        maxCount={5}
                                        accept="image/*"
                                    >
                                        {fileList.length >= 5 ? null : (
                                            <div>
                                                <UploadOutlined />
                                                <div style={{ marginTop: 8 }}>Subir imagen</div>
                                            </div>
                                        )}
                                    </Upload>
                                    <div style={{ marginTop: 8, fontSize: '12px', color: '#666' }}>
                                        Máximo 5 imágenes, 10MB por archivo. Formatos: JPG, PNG, GIF, WEBP
                                    </div>
                                </Form.Item>
                            </Col>
                        </Row>
                        <br />
                        <Flex justify="center">
                            <Button loading={cargando} type="primary" htmlType="submit">Enviar</Button>
                        </Flex>
                        
                    </Form>
                </Card>
            </Flex>}
            
            {/* Modal de previsualización de imágenes */}
            <Image
                preview={{
                    visible: previewVisible,
                    onVisibleChange: setPreviewVisible,
                }}
                src={previewImage}
                style={{ display: 'none' }}
            />
        </div>
    );
};

export default ReporteGuardar;
